import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const SOCIAL_ICONS: Record<string, string> = {
  instagram: 'assets/icon/social/instagram-2016-6.svg',
  discord: 'assets/icon/social/discord.svg',
  reddit: 'assets/icon/social/reddit.svg',
};

@Injectable({ providedIn: 'root' })
export class SocialIconRegistryService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  register(): void {
    for (const [name, path] of Object.entries(SOCIAL_ICONS)) {
      this.matIconRegistry.addSvgIcon(
        name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(path),
      );
    }
  }
}
